// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__LVnly","row":"Node_row__1PdiY","label":"Node_label__mJIfH","footer":"Node_footer__2yaZf"};